import { onlineManager } from '@tanstack/react-query';
import { onlineOrderBookStoreRepositoryOfflineAdapters } from '../../../modules/offline/offlineRequestAdapters/onlineOrderBookStore.repository.offlineAdapters';
import onlineOrderBookStoreRepository from './onlineOrderBookStore.repository';

export const orderBookStoreRepository = (isOfflineMode = false) =>
  isOfflineMode || !onlineManager.isOnline()
    ? onlineOrderBookStoreRepositoryOfflineAdapters()
    : onlineOrderBookStoreRepository();
